var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelEditRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5562_603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70714 3.29289C4.31661 2.90237 3.68345 2.90237 3.29292 3.29289C2.9024 3.68342 2.9024 4.31658 3.29292 4.70711L8.59021 10.0044L5.29392 13.2914C5.18365 13.4014 5.10059 13.5356 5.05134 13.6833L3.05134 19.6833C2.93157 20.0426 3.02509 20.4388 3.29292 20.7066C3.56075 20.9745 3.95692 21.068 4.31625 20.9482L7.28205 19.9596C7.30546 19.9527 7.32867 19.945 7.35163 19.9364L10.3163 18.9482C10.4631 18.8993 10.5965 18.8169 10.7061 18.7076L14.0044 15.4186L19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0977 20.3166 21.0977 19.6834 20.7071 19.2929L14.7989 13.3847C14.7744 13.3533 14.7476 13.323 14.7187 13.2941C14.6892 13.2644 14.6582 13.237 14.6261 13.2119L4.70714 3.29289ZM12.5902 14.0044L10.0044 11.4186L6.87382 14.5404L6.14403 16.7298L7.26976 17.8555L9.46055 17.1253L12.5902 14.0044Z",
    fill: "#E64545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4899 4.1195C15.9856 2.62797 18.4067 2.62965 19.9004 4.12327C21.3969 5.61984 21.3952 8.04678 19.8966 9.54126L17.7235 11.7083C17.3325 12.0982 16.6993 12.0974 16.3093 11.7063C15.9193 11.3152 15.9202 10.682 16.3113 10.2921L18.4843 8.12507C19.2001 7.41132 19.2009 6.25224 18.4861 5.53749C17.7728 4.82415 16.6165 4.82334 15.9022 5.53568L13.7235 7.70825C13.3325 8.09823 12.6993 8.09735 12.3093 7.70628C11.9193 7.31521 11.9202 6.68205 12.3113 6.29207L14.4899 4.1195Z",
    fill: "#E64545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5562_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelEditRed);
export default __webpack_public_path__ + "static/media/CancelEditRed.9ca16e3ea31b669cc779fccd2894d1db.svg";
export { ForwardRef as ReactComponent };